import cookie from 'js-cookie';
import { getLogger, getUuid } from '@spotify-internal/remote-config-common';
const SPT_COOKIE_KEY = 'sp_t';
const YEAR_IN_MILLIS = 3600 * 24 * 366 * 1000;
export const writeSPTCookie = (value) => {
    const setCookie = cookie.set(SPT_COOKIE_KEY, value, {
        expires: Date.now() + YEAR_IN_MILLIS,
        path: '/',
    });
    if (!setCookie) {
        throw new Error('Unable to set sp_t cookie');
    }
};
function isValidSptCookie(sp_t) {
    return typeof sp_t === 'string' && sp_t.length > 5;
}
function getSptCookie(sp_t_cookie) {
    if (sp_t_cookie) {
        return sp_t_cookie;
    }
    return cookie.get(SPT_COOKIE_KEY);
}
export const sptCookieMiddleware = next => opt => {
    const logger = getLogger('middleware:sptcookie');
    const sp_t_cookie = getSptCookie(opt.sp_t_cookie);
    if (!isValidSptCookie(sp_t_cookie)) {
        const generatedSPTCookie = getUuid();
        try {
            writeSPTCookie(generatedSPTCookie);
        }
        catch (e) {
            logger.error('error writing spt cookie', e);
        }
        return ctx => next(Object.assign(Object.assign({}, ctx), { sp_t_cookie: generatedSPTCookie }));
    }
    return ctx => next(Object.assign(Object.assign({}, ctx), { sp_t_cookie }));
};
//# sourceMappingURL=sptCookie.js.map